var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-manage-container", staticStyle: { padding: "10px" } },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "border-card" },
          model: {
            value: _vm.activity,
            callback: function ($$v) {
              _vm.activity = $$v
            },
            expression: "activity",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "團體App", name: "groupTravel" } },
            [
              _c(
                "el-form",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticStyle: { margin: "10px" },
                  attrs: { inline: true, size: "mini" },
                  model: {
                    value: _vm.travelAllowDaysSettings,
                    callback: function ($$v) {
                      _vm.travelAllowDaysSettings = $$v
                    },
                    expression: "travelAllowDaysSettings",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "領隊可提前登入天數" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0, max: 100, label: "請輸入領隊天數" },
                        model: {
                          value: _vm.travelAllowDaysSettings.leader,
                          callback: function ($$v) {
                            _vm.$set(_vm.travelAllowDaysSettings, "leader", $$v)
                          },
                          expression: "travelAllowDaysSettings.leader",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "旅客可提前登入天數" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0, max: 100, label: "請輸入旅客天數" },
                        model: {
                          value: _vm.travelAllowDaysSettings.travelers,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.travelAllowDaysSettings,
                              "travelers",
                              $$v
                            )
                          },
                          expression: "travelAllowDaysSettings.travelers",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "資料刪除天數" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0, max: 50, label: "請輸入資料刪除天數" },
                        model: {
                          value: _vm.travelAllowDaysSettings.delete,
                          callback: function ($$v) {
                            _vm.$set(_vm.travelAllowDaysSettings, "delete", $$v)
                          },
                          expression: "travelAllowDaysSettings.delete",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "網卡運送機場費用" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0, label: "請輸入網卡運送機場費用" },
                        model: {
                          value: _vm.travelAllowDaysSettings.networkPostFee,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.travelAllowDaysSettings,
                              "networkPostFee",
                              $$v
                            )
                          },
                          expression: "travelAllowDaysSettings.networkPostFee",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "足跡景點半徑(公尺)" } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          min: 1,
                          max: 1000,
                          label: "請輸入足跡景點半徑(公尺)",
                        },
                        model: {
                          value: _vm.travelAllowDaysSettings.viewPointRadius,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.travelAllowDaysSettings,
                              "viewPointRadius",
                              $$v
                            )
                          },
                          expression: "travelAllowDaysSettings.viewPointRadius",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "旅客報到半徑(公尺)" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 1, label: "請輸入旅客報到半徑(公尺)" },
                        model: {
                          value:
                            _vm.travelAllowDaysSettings.travelerCheckInRadius,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.travelAllowDaysSettings,
                              "travelerCheckInRadius",
                              $$v
                            )
                          },
                          expression:
                            "travelAllowDaysSettings.travelerCheckInRadius",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "科威API開放期限" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "date",
                          placeholder: "請選擇開始日期",
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd",
                        },
                        model: {
                          value: _vm.travelAllowDaysSettings.coWellStartDate,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.travelAllowDaysSettings,
                              "coWellStartDate",
                              $$v
                            )
                          },
                          expression: "travelAllowDaysSettings.coWellStartDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "至" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "date",
                          placeholder: "請選擇結束日期",
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd",
                        },
                        model: {
                          value: _vm.travelAllowDaysSettings.coWellEndDate,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.travelAllowDaysSettings,
                              "coWellEndDate",
                              $$v
                            )
                          },
                          expression: "travelAllowDaysSettings.coWellEndDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "旅客打卡半徑(公尺)" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 1, label: "請輸入旅客打卡半徑(公尺)" },
                        model: {
                          value: _vm.travelAllowDaysSettings.checkInRadius,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.travelAllowDaysSettings,
                              "checkInRadius",
                              $$v
                            )
                          },
                          expression: "travelAllowDaysSettings.checkInRadius",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "success" },
                          on: { click: _vm.saveData },
                        },
                        [_vm._v("儲存")]
                      ),
                      _c("el-button", {
                        staticStyle: { cursor: "pointer" },
                        attrs: {
                          loading: _vm.loading,
                          type: "primary",
                          icon: "el-icon-refresh-left",
                          circle: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.fetchData()
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading",
                        },
                      ],
                      staticStyle: { width: "100%" },
                      attrs: {
                        border: "",
                        height: "500",
                        data: _vm.list,
                        stripe: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "date", label: "項次", width: "50" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [_vm._v(_vm._s(scope.$index + 1))]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "date", label: "日期", width: "180" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [_vm._v(_vm._s(scope.row.buildDate))]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "date", label: "內容", width: "1200" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [_vm._v(_vm._s(scope.row.jsonData))]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "date", label: "異動者", width: "80" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [_vm._v(_vm._s(scope.row.buildUserID))]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }